import HtmlElement from '../../../Elements/HtmlElement';

/**
 * CtaButton
 */
const CtaButton = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		CTA_BUTTON: '.cta-button'
	};

	/**
	 * CtaButton
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class CtaButton extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this.centerText();
			this.$element.addClass('show');

			window.addEventListener('resize', () => {
				if (this._isResponsive()) {
					$('.footer-bar').css('--cta-button-height', `${this.$element.outerHeight() + 5}px`);
				} else {
					$('.footer-bar').css('--cta-button-height', ``);
				}
			});

			this._setOffset();

			window.addEventListener('scroll', () => {
				this._setOffset();
			});
		}

		centerText() {
			const $div = this.$element.find('.cta-button-text > .horizontal-alignment');
			$div.css('padding-top', `${$div.parent().outerHeight() / 2 - $div.outerHeight() / 2 - 2}px`);
		}

		_isResponsive() {
			return $(window).width() < 1024;
		}

		_setOffset() {
			if ((window.innerHeight + window.scrollY + 30) >= document.body.offsetHeight) {
				this.$element.addClass('scrolled-bottom');
			} else {
				this.$element.removeClass('scrolled-bottom');
			}
		}
	}

	return CtaButton._getElements(Selector.CTA_BUTTON, CtaButton);
})();

export default CtaButton;
